import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { memo } from 'react';
var filterProps = {
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
};
var Filters = memo(function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  var _a;
  var isFireFox = (((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) || "").includes("Firefox/");
  return /* @__PURE__ */jsxs(Fragment, {
    children: [!isFireFox && /* @__PURE__ */jsxs("filter", _objectSpread(_objectSpread({
      id: "fill-filter",
      x: "-50%",
      y: "-50%",
      width: "200%",
      height: "200%"
    }, filterProps), {}, {
      children: [/* @__PURE__ */jsx("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
      }), /* @__PURE__ */jsx("feFlood", {
        floodColor: backgroundColor,
        result: "bg"
      }), /* @__PURE__ */jsx("feComposite", {
        operator: "in",
        in: "bg",
        in2: "hardAlpha",
        result: "bgMask"
      }), /* @__PURE__ */jsx("feGaussianBlur", {
        in: "bgMask",
        stdDeviation: "75",
        result: "blur"
      }), /* @__PURE__ */jsx("feComposite", {
        operator: "in",
        in: "blur",
        in2: "hardAlpha",
        result: "blurred"
      }), /* @__PURE__ */jsxs("feMerge", {
        children: [/* @__PURE__ */jsx("feMergeNode", {
          in: "SourceGraphic"
        }), /* @__PURE__ */jsx("feMergeNode", {
          in: "blurred"
        })]
      })]
    }), "fill-filter"), /* @__PURE__ */jsxs("filter", _objectSpread(_objectSpread({
      id: "border-filter",
      x: "-100%",
      y: "-100%",
      width: "300%",
      height: "300%"
    }, filterProps), {}, {
      children: [/* @__PURE__ */jsx("feGaussianBlur", {
        in: "SourceGraphic",
        stdDeviation: "50",
        result: "blur1"
      }), /* @__PURE__ */jsx("feGaussianBlur", {
        in: "SourceGraphic",
        stdDeviation: "25",
        result: "blur2"
      }), /* @__PURE__ */jsxs("feMerge", {
        children: [/* @__PURE__ */jsx("feMergeNode", {
          in: "blur1"
        }), /* @__PURE__ */jsx("feMergeNode", {
          in: "blur2"
        }), /* @__PURE__ */jsx("feMergeNode", {
          in: "SourceGraphic"
        })]
      })]
    }), "border-filter")]
  });
});
Filters.displayName = "WarzoneMapFilters";
export { Filters };